/* eslint-disable */
/**
 * Typeahead module.
 * @exports modules/typeahead
 * @version 0.1.0
 */
(function() {
  var $ = require('jquery');
  var Handlebars = require('handlebars');
  require('typeahead-core');
  const Bloodhound = require('typeahead-bloodhound');

  var self = {};

  /** The suggestion engine used by Twitter Typeahead. */
  var data = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    limit: 10,
    remote: {
      url: '/api/typeahead/getsearchitems?query=%QUERY',
      filter: dataFilter,
      wildcard: '%QUERY',
    },
    dupDetector: function(remoteMatch, localMatch) {
      return remoteMatch.value === localMatch.value && remoteMatch.url === localMatch.url;
    },
  });

  /** Process data from handler into datums.
   * @param (object) list
   */
  function dataFilter(list) {
    return $.map(list, function(item) {
      return {
        name: item,
      };
    });
  }

  /** Redirect to suggestion URL when selected.
   * @param (object) event
   * @param (object) suggestion
   * @param (string) name
   */
  function redirect(event, suggestion, name) {
    if (suggestion.name && suggestion.name.url) {
      window.location.href = suggestion.name.url;
    }
  }

  /** Initialise module.
   * @param (object) $target
   */
  self.initialise = function($target) {
    // Start pre-fetch of results.
    data.initialize();

    if ($target && $target.typeahead) {
      // Initialise type ahead plugin.
      $target
        .typeahead(null, {
          name: 'data',
          display: 'value',
          source: data,
          templates: {
            // https://github.com/twitter/typeahead.js/blob/master/doc/jquery_typeahead.md#look-and-feel
            // suggestion: Handlebars.compile('{{#if image}}<img src="{{image}}" alt="{{value}}" />{{/if}}{{value}}')
            suggestion: Handlebars.compile(
              '<div>{{{image name.image name.value}}}<span>{{name.value}}</span></div>',
            ),
          },
        })
        .on('typeahead:selected', redirect);
    }
  };

  module.exports = self;
})();
